import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import FormStatus from '../../../../components/ui/FormStatus/FormStatus'
import mobileNumberInput from '../../../../services/input/mobileNumberInput'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import TextInput from '../../../../components/ui/SimplifiedLogin/TextInput/TextInput'
import { setGACustomPageView } from '../../../../services/analytics/google-analytics'
import Checkbox from '../../../../components/ui/Checkbox/Checkbox'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`
const BlockButton = styled(ActionButton)`
  width: 100%;
`
const AgreementContainer = styled.div`
  display: flex;
`
const StyledCheckbox = styled(Checkbox)`
  border-radius: var(--border-radius-form);
  border: var(--border-form);
  margin-top: 0.1rem;
  margin-right: 0.8rem;
`
const TermsAndPrivacyAgreement = styled.p`
  margin: 0;
  font-size: 12px;
`
const StyledAnchorTag = styled.a`
  color: var(--color-primary);
  text-decoration: none;
`

const LoginForm = props => {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    // isValid,
    disabled,
    method,
    action,
    setStatus,
    status,
  } = props
  const [userAgreement, setUserAgreement] = React.useState(false)
  const toggleUserAgreement = () => setUserAgreement(!userAgreement)
  const clearStatus = () => {
    if (props.status && setStatus) setStatus({})
  }

  return (
    <form
      onSubmit={handleSubmit}
      method={method}
      action={action}
      data-testid="registerMobileForm"
    >
      <fieldset disabled={isSubmitting || disabled}>
        <FormStatus variant={status.error ? 'error' : 'message'}>
          {status.error || status.message}
        </FormStatus>
        <TextInput
          name="username"
          type="text"
          bold="boldest"
          label="Sign up with Mobile Number"
          maxLength={11}
          initialValue={values.username}
          error={errors.username}
          touched={touched.username}
          onChange={e => {
            mobileNumberInput(e, handleChange)
            clearStatus()
          }}
          onBlur={handleBlur}
          valueColor="primary"
          data-testid="username"
        />
        <AgreementContainer id="agreementContainer">
          <StyledCheckbox
            id="userAgreement"
            onChange={toggleUserAgreement}
            data-testid="userAgreement"
          />
          <TermsAndPrivacyAgreement>
            By proceeding, I have read and agreed to Zing at Ayala Malls’&nbsp;
            <StyledAnchorTag
              title="Terms and Conditions"
              target="_blank"
              rel="noopener noreferrer"
              href="/webview/terms-and-conditions"
              onClick={() => {
                setGACustomPageView({
                  page: '/webview/terms-and-conditions',
                  title: 'Registration - Terms and Conditions',
                })
              }}
            >
              Terms &amp; Conditions
            </StyledAnchorTag>
            &nbsp;and&nbsp;
            <StyledAnchorTag
              title="Privacy Notice"
              target="_blank"
              rel="noopener noreferrer"
              href="/webview/privacy-notice"
              onClick={() => {
                setGACustomPageView({
                  page: '/webview/privacy-notice',
                  title: 'Registration - Privacy Notice',
                })
              }}
            >
              Privacy Notice
            </StyledAnchorTag>
          </TermsAndPrivacyAgreement>
        </AgreementContainer>
        <ButtonWrapper>
          <BlockButton
            type="submit"
            variant="primary"
            disabled={!!errors.username || !userAgreement}
            data-testid="registerMobileSubmit"
          >
            Register
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

LoginForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
  status: {},
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
  status: PropTypes.shape(),
}

export default LoginForm
